import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _I18nextTranslator;
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context6, _context7; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context6 = ownKeys(Object(t), !0)).call(_context6, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context7 = ownKeys(Object(t))).call(_context7, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import i18next from 'i18next';
import { dayjs } from './dayjs';
export var SupportedLanguages = /*#__PURE__*/function (SupportedLanguages) {
  SupportedLanguages["de"] = "de";
  SupportedLanguages["fr"] = "fr";
  SupportedLanguages["it"] = "it";
  SupportedLanguages["en"] = "en";
  return SupportedLanguages;
}({});
var isSupportedLanguage = function isSupportedLanguage(lang) {
  var _context;
  return _includesInstanceProperty(_context = _Object$keys(SupportedLanguages)).call(_context, lang);
};
export var I18nextTranslator = /*#__PURE__*/function () {
  function I18nextTranslator() {
    var _this = this;
    _classCallCheck(this, I18nextTranslator);
    _defineProperty(this, "_i18next", void 0);
    _defineProperty(this, "namespaces", []);
    /**
     * @param Resources { [translation:SupportedLanguages]: { [namespace:string]: translations: any } }
     *
     * @see https://www.i18next.com/how-to/add-or-load-translations
     */
    _defineProperty(this, "init", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(language, namespaces, translations) {
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this.namespaces = namespaces;
              _context2.next = 3;
              return _this._i18next.init({
                ns: namespaces,
                supportedLngs: _Object$keys(SupportedLanguages),
                lng: language,
                fallbackLng: SupportedLanguages.de,
                resources: _defineProperty({}, language, translations)
              });
            case 3:
              dayjs.locale(language);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getNamespaces", function () {
      return _this.namespaces;
    });
    _defineProperty(this, "getLanguage", function () {
      return isSupportedLanguage(_this._i18next.language) ? _this._i18next.language : SupportedLanguages.de;
    });
    _defineProperty(this, "isInitialized", function () {
      return _this._i18next.isInitialized;
    });
    _defineProperty(this, "getI18next", function () {
      return _this._i18next;
    });
    _defineProperty(this, "t", function (key, options) {
      var _options$ns;
      return _this._i18next.t(key, _objectSpread(_objectSpread({}, options), {}, {
        ns: (_options$ns = options === null || options === void 0 ? void 0 : options.ns) !== null && _options$ns !== void 0 ? _options$ns : _this.namespaces
      }));
    });
    /**
     * Load newly added namespaces (execute after addTranslations)
     *
     * @param namespaces
     */
    _defineProperty(this, "updateNamespaces", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(namespaces) {
        var _context3;
        return _regeneratorRuntime.wrap(function _callee2$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this._i18next.loadNamespaces(namespaces);
            case 2:
              _this.namespaces = _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(_this.namespaces), _toConsumableArray(_filterInstanceProperty(namespaces).call(namespaces, function (namespace) {
                var _context4;
                return !_includesInstanceProperty(_context4 = _this.namespaces).call(_context4, namespace);
              })));
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee2);
      }));
      return function (_x4) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "addTranslations", function (language, namespace, resources) {
      _this._i18next.addResourceBundle(language, namespace, resources);
    });
    this._i18next = i18next;
  }
  return _createClass(I18nextTranslator, null, [{
    key: "getInstance",
    value: function getInstance() {
      if (!I18nextTranslator.instance) {
        I18nextTranslator.instance = new I18nextTranslator();
      }
      return I18nextTranslator.instance;
    }
  }]);
}();
_I18nextTranslator = I18nextTranslator;
_defineProperty(I18nextTranslator, "instance", void 0);
export var translatorInstance = I18nextTranslator.getInstance();